import React, { useMemo } from 'react';
import classNames from 'classnames';
import './CustomSVG.scss';

/**
 * Renders SVG, extracts raw content that can be customized through props
 */
export const CustomSVG = ({ svg, viewBox, className, children, ...props }) => {
    const parsedSVG = useMemo(() => {
        if (!svg) return null;

        const parser = new DOMParser();
        const doc = parser.parseFromString(svg, 'image/svg+xml');
        const svgElement = doc.querySelector('svg');

        if (!svgElement) {
            return null;
        }

        const paths = Array.from(svgElement.querySelectorAll('path')).map((path) => ({
            className: path.getAttribute('class'),
            d: path.getAttribute('d'),
        }));

        return {
            viewBox: svgElement.getAttribute('viewBox'),
            paths,
        };
    }, [svg]);

    const finalViewBox = viewBox || parsedSVG?.viewBox;
    const pathElements =
        parsedSVG?.paths?.length > 0
            ? parsedSVG.paths.map((path, index) => (
                  <path key={index} className={classNames(path.className)} d={path.d} />
              ))
            : children;

    return (
        <svg viewBox={finalViewBox} className={classNames('rm-svg', className)} {...props}>
            {pathElements}
        </svg>
    );
};
